(() => {
  if (window.KobuCollectionLandingInitialized) {
    return;
  }

  window.KobuCollectionLandingInitialized = true;

  function initSlider(section) {
    if (!section || section.dataset.kobuSliderReady === 'true') {
      return;
    }

    const track = section.querySelector('[data-kobu-slider-track]');
    const slides = Array.from(section.querySelectorAll('[data-kobu-slide]'));
    const dots = Array.from(section.querySelectorAll('[data-kobu-dot]'));
    const prev = section.querySelector('[data-kobu-prev]');
    const next = section.querySelector('[data-kobu-next]');
    const autoplay = section.dataset.kobuAutoplay === 'true';
    const speed = Number(section.dataset.kobuAutoplaySpeed || '4500');

    if (!track || slides.length < 2) {
      section.dataset.kobuSliderReady = 'true';
      return;
    }

    let index = 0;
    let timer = null;

    function update() {
      track.style.transform = `translateX(-${index * 100}%)`;

      slides.forEach((slide, slideIndex) => {
        slide.setAttribute('aria-hidden', slideIndex === index ? 'false' : 'true');
      });

      dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === index);
        dot.setAttribute('aria-current', dotIndex === index ? 'true' : 'false');
      });
    }

    function goTo(nextIndex) {
      index = (nextIndex + slides.length) % slides.length;
      update();
    }

    function startAutoplay() {
      if (!autoplay) {
        return;
      }

      stopAutoplay();
      timer = window.setInterval(() => {
        goTo(index + 1);
      }, speed);
    }

    function stopAutoplay() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    prev?.addEventListener('click', () => {
      goTo(index - 1);
      startAutoplay();
    });

    next?.addEventListener('click', () => {
      goTo(index + 1);
      startAutoplay();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        goTo(dotIndex);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    update();
    startAutoplay();
    section.dataset.kobuSliderReady = 'true';
  }

  function initProductPicker(section) {
    if (!section || section.dataset.kobuProductsReady === 'true') {
      return;
    }

    const cards = Array.from(section.querySelectorAll('[data-kobu-product-card]'));
    const stickyInput = section.querySelector('[data-kobu-sticky-variant]');
    const stickyTitle = section.querySelector('[data-kobu-sticky-title]');
    const stickyPrice = section.querySelector('[data-kobu-sticky-price]');
    const stickySubmit = section.querySelector('[data-kobu-sticky-submit]');

    if (!cards.length || !stickyInput || !stickyTitle || !stickyPrice || !stickySubmit) {
      section.dataset.kobuProductsReady = 'true';
      return;
    }

    function updateSticky(card) {
      const isAvailable = card.dataset.kobuAvailable === 'true';
      stickyInput.value = card.dataset.kobuVariantId || '';
      stickyTitle.textContent = card.dataset.kobuTitle || '';
      stickyPrice.textContent = card.dataset.kobuPrice || '';
      stickySubmit.disabled = !isAvailable;
      stickySubmit.textContent = isAvailable ? (section.dataset.kobuStickyLabel || 'Add to Cart') : 'Sold Out';
    }

    function setActive(card) {
      cards.forEach((item) => {
        item.classList.toggle('is-active', item === card);
      });

      updateSticky(card);
    }

    cards.forEach((card) => {
      card.addEventListener('click', (event) => {
        if (event.target.closest('form, a, [data-kobu-select-ignore]')) {
          return;
        }

        setActive(card);
      });

      const selectButton = card.querySelector('[data-kobu-select-card]');
      selectButton?.addEventListener('click', () => {
        setActive(card);
      });
    });

    const initialCard =
      cards.find((card) => card.classList.contains('is-featured')) ||
      cards.find((card) => card.classList.contains('is-active')) ||
      cards[0];

    if (initialCard) {
      setActive(initialCard);
    }

    section.dataset.kobuProductsReady = 'true';
  }

  function initAll(root) {
    root.querySelectorAll('[data-kobu-social-proof]').forEach(initSlider);
    root.querySelectorAll('[data-kobu-product-picker]').forEach(initProductPicker);
  }

  document.addEventListener('DOMContentLoaded', () => initAll(document));
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
